import React, { useEffect, useState } from "react";
import CoursesFeatures from "../components/courses/CoursesFeatures";
import GridCourses from "../components/home/GridCourses";
import { Grid } from "@material-ui/core";
import Navbar from "../components/global/Navbar";
import Footer from "../components/global/Footer";
import "../css/SingleCurso.css";
import CoursesHeader from "../components/courses/CoursesHeader";

const features = [
  "Aprende a tu ritmo y en los horarios que mejor se adapten a ti.",
  "Certifícate desde cualquier parte del mundo.",
  "Soporte en línea con nuestras master coaches.",
];

const OnDemandCourses = () => {
  const [view, setView] = useState("");

  useEffect(() => {
    const container = document.getElementById("certificaciones");
    if (container && container !== null) container.scrollIntoView();
  }, [view]);

  return (
    <div className="bg-light overflow-x-hidden">
      <Navbar />
      <CoursesHeader />
      <div className="h-100 py-4">
        <Grid className="justify-content-center align-items-center">
          <div className="d-flex flex-column w-100">
            <h1 className="h2 text-center">
              Certificaciones On Demand
            </h1>
            <div className="separator my-3"></div>
          </div>
          <p className="text-center large w-100">
            Una modalidad diseñada para que estudies a tu ritmo, en tus propios tiempos, con flexibilidad, atención de dudas y retroalimentación que acompañan tu proceso.
          </p>
          <CoursesFeatures features={features} />
          <div className="container my-3 my-md-5">
            <h1 className="h2 text-center mb-5">
              Selecciona para ver Certificaciones
            </h1>
            <div className="row g-4">
              <div className="col-12 col-md-6">
                <div
                  role="button"
                  tabIndex={0}
                  className={`card text-center px-0 py-0 shadow overflow-hidden h-100 border border-3 ${
                    view === "new"
                      ? "border-primary"
                      : "border-transparent"
                  }`}
                  style={{ borderRadius: "16px", cursor: "pointer" }}
                  onClick={() => setView("new")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setView("new");
                    }
                  }}
                >
                  <div
                    className="w-100"
                    style={{
                      minHeight: "400px",
                      backgroundImage:
                        "url(https://tbmcerts.s3.us-west-1.amazonaws.com/ondemand-quieroser-2.jpg)",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: "16px 16px 0 0",
                    }}
                    role="img"
                    aria-label="Quiero ser TBM Certified"
                  />
                  <div className="bg-primary text-white py-3 px-3">
                    <h3 className="h4 mb-0">Quiero ser TBM Certified</h3>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div
                  role="button"
                  tabIndex={0}
                  className={`card text-center px-0 py-0 shadow overflow-hidden h-100 border border-3 ${
                    view === "certified"
                      ? "border-primary"
                      : "border-transparent"
                  }`}
                  style={{ borderRadius: "16px", cursor: "pointer" }}
                  onClick={() => setView("certified")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setView("certified");
                    }
                  }}
                >
                  <div
                    className="w-100"
                    style={{
                      minHeight: "400px",
                      backgroundImage:
                        "url(https://tbmcerts.s3.us-west-1.amazonaws.com/ondemand-yasoy-2.jpg)",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: "16px 16px 0 0",
                    }}
                    role="img"
                    aria-label="Ya soy TBM Certified"
                  />
                  <div className="bg-primary text-white py-3 px-3">
                    <h3 className="h4 mb-0">Ya soy TBM Certified</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {view !== "" && (
            <Grid
              item
              xs={12}
              id="certificaciones"
              className="gridCertificaciones mb-5 justify-content-center align-items-center"
            >
              <Grid item xs={12} className="px-3 px-xl-5 mb-5">
                <GridCourses mode="on-demand" view={view} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
      <Footer />
    </div>
  );
};

export default OnDemandCourses;
